import { FC } from 'react'

import {
  CheckBox,
  Grid,
  Input,
  SimpleCollapse,
  CurrencyInput
} from 'components'
import { SPACING } from 'utils'
export interface IEncargosCollapse {
  control: any
  errors: any
  disabledFunctions?: boolean
  novaAnalise?: boolean
}
const EncargosCollapse: FC<IEncargosCollapse> = ({
  control,
  errors,
  disabledFunctions,
  novaAnalise
}) => {
  return (
    <SimpleCollapse title="ENCARGOS DO EFETIVO">
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1.2fr 0.6fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing5} 0`}
      >
        <CurrencyInput
          control={control}
          errors={errors}
          label="GPS"
          placeholder="R$"
          formValue="vlrGPS"
          disabled={disabledFunctions ? disabledFunctions : !novaAnalise}
        />
        <CurrencyInput
          control={control}
          errors={errors}
          label="GFIP"
          placeholder="R$"
          formValue="vlrGFIP"
          disabled={disabledFunctions ? disabledFunctions : !novaAnalise}
        />
        <CurrencyInput
          control={control}
          errors={errors}
          label="DAS"
          placeholder="R$"
          formValue="vlrDAS"
          disabled={disabledFunctions ? disabledFunctions : !novaAnalise}
        />
        <div />
        <Input
          control={control}
          errors={errors}
          label="CNO (Cadastro Nacional de Obras)"
          placeholder="CNO"
          formValue="txCNO"
          disabled
        />
        <div />
        <CheckBox
          control={control}
          label="Denúncia"
          formValue="flDenuncia"
          onClick={(e) => e.preventDefault()}
          onChange={(e) => e.preventDefault()}
          disabled
        />
        <CheckBox
          control={control}
          label="Alerta"
          formValue="flAlerta"
          onClick={(e) => e.preventDefault()}
          onChange={(e) => e.preventDefault()}
          disabled
        />
      </Grid>
    </SimpleCollapse>
  )
}

export default EncargosCollapse
